<template>
  <ontick-table :fixed="true">
    <ontick-table-tr slot="head">
      <ontick-table-th
        v-for="i in 10"
        :key="i"
        style="padding-left: 0px !important; padding-right: 0px !important"
      >
        <div class="flex animate-pulse space-x-4">
          <div class="flex-1">
            <div class="flex items-center">
              <div class="w-full space-y-3 px-3">
                <div
                  class="h-6 rounded bg-gray-50 dark:bg-ontick-carbon-500"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </ontick-table-th>
    </ontick-table-tr>
    <template slot="body">
      <ontick-table-tr v-for="i in 5" :key="i">
        <ontick-table-td
          v-for="j in 10"
          :key="j"
          style="padding-left: 0px !important; padding-right: 0px !important"
        >
          <div class="flex animate-pulse space-x-4">
            <div class="flex-1 space-y-4 py-1">
              <div class="flex items-center">
                <div class="w-full space-y-3 px-3">
                  <!-- <div class="h-6 bg-ontick-carbon rounded"></div>
                  <div class="h-6 bg-ontick-carbon rounded"></div> -->
                  <div
                    class="h-6 rounded bg-gray-50 dark:bg-ontick-carbon-500"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </ontick-table-td>
      </ontick-table-tr>
    </template>
  </ontick-table>
</template>

<script>
export default {
  name: "placeholder-table",
};
</script>
